import { PathConfig, IH5AppURLBuilder} from '@/types';
import { autoAppendSlash } from './index';
import { parse as parseQuery, stringify as stringifyQuery } from 'query-string';

export const createUrlBuilder = (args: PathConfig): IH5AppURLBuilder => {
  let { prefix = '', routes = [], notFound = '', persistedQueryKeys = [] } = args;

  prefix = autoAppendSlash(prefix);

  return {
    parse(url: URL) {
      const webOriginPath = url.pathname;
      const matchedItem = routes.find(item => prefix + item.webPath === webOriginPath);

      if (!matchedItem) {
        return notFound;
      }

      const miniPath = matchedItem.miniPath;

      return miniPath + url.search;
    },
    format(pageInfo) {
      const matchedItem = routes.find(item => item.miniPath === pageInfo.pagePath);
      const path = prefix + matchedItem.webPath;
      
      const result = new URL(window.location.href);
      result.pathname = path;

      const resultQuery: Record<string, any> = {
        ...parseQuery(pageInfo.queryString)
      };

      // 强制保留的全局参数, 页面参数和全局参数不能同名
      persistedQueryKeys.forEach(key => {
        const v = result.searchParams.get(key);
        if (v) {
          resultQuery[key] = v;
        }
      });
      result.search = stringifyQuery(resultQuery);

      return result;
    }
  }
}
